var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4868_268386)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4868_268386",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14.9495V15.5C1 17.433 2.567 19 4.5 19H19.5C21.433 19 23 17.433 23 15.5V14.9495C22.3647 15.5977 21.4793 16 20.5 16H3.5C2.52066 16 1.63526 15.5977 1 14.9495Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00391 18.665C3.09006 20.5214 4.6224 22 6.50009 22H17.5001C19.3778 22 20.9101 20.5214 20.9963 18.665C20.5426 18.8799 20.0354 19 19.5001 19H4.50009C3.96479 19 3.45756 18.8799 3.00391 18.665Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 2C1.567 2 0 3.567 0 5.5V12.5C0 14.433 1.567 16 3.5 16H20.5C22.433 16 24 14.433 24 12.5V5.5C24 3.567 22.433 2 20.5 2H3.5ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z",
    fill: "url(#paint0_linear_4868_268386)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5C0 3.567 1.567 2 3.5 2H5V16H3.5C1.567 16 0 14.433 0 12.5V5.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.5C24 3.567 22.433 2 20.5 2H19V16H20.5C22.433 16 24 14.433 24 12.5V5.5Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4868_268386)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#2C2E34"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4868_268386",
    x1: 3.81818,
    y1: 4.22727,
    x2: 10.823,
    y2: 18.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4868_268386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.39e8487834939487683c48630943b29d.svg";
export { ForwardRef as ReactComponent };